export function pushDataLayer(event: any) {
  if (
    typeof window !== "undefined" &&
    "dataLayer" in window &&
    Array.isArray(window.dataLayer)
  ) {
    window.dataLayer.push(event);
  }
}
